export default __webpack_public_path__ + "static/media/fsd.b1c7275b.png";